import * as z from "zod/v4";

export const getInventoryValue = {
  name: "getInventoryValue" as const,
  input: z.object({}),
  output: z.object({ inventoryValue: z.number() }),
};
